exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(true);
// Module
exports.push([module.id, ".videoInfoStyle_videoBody_1jVjJ6BZcQ1v6EnnXr5pVt{overflow-x:hidden;text-overflow:ellipsis}.videoInfoStyle_text_3aI34H-kPym7ElpO3bZcV{margin-top:35px}\n", "",{"version":3,"sources":["videoInfoStyle.scss"],"names":[],"mappings":"AAAA,iDAAW,iBAAiB,CAAC,sBAAsB,CAAC,2CAAM,eAAe","file":"videoInfoStyle.scss","sourcesContent":[".videoBody{overflow-x:hidden;text-overflow:ellipsis}.text{margin-top:35px}\n"]}]);

// Exports
exports.locals = {
	"videoBody": "videoInfoStyle_videoBody_1jVjJ6BZcQ1v6EnnXr5pVt",
	"text": "videoInfoStyle_text_3aI34H-kPym7ElpO3bZcV"
};